import { useEffect } from "react"

import { Col, Row, Skeleton } from "antd"
import { useDispatch, useSelector } from "react-redux"

import { useExternalDemoMode } from "../../hooks/useExternalDemoMode"
import ComingSoonCard from "./components/ComingSoonCard"
import PerkCard from "./components/PerkCard"
import { getPerks } from "./redux/perks.thunks"

import "./styles.less"

const SKELETON_KEYS = [0, 1, 2, 3, 4, 5]

const breakpoints = {
  xs: 24,
  md: 12,
  xl: 8,
  xxl: 6
}

const PerksPage = () => {
  const dispatch = useDispatch()
  const { list, fetching } = useSelector((state) => state.perks)
  const isDemo = useSelector((state) => state.auth?.userInfo?.is_demo)
  const isLightMode = useSelector((state) => state.auth?.userInfo?.is_light_mode)
  const externalDemoMode = useExternalDemoMode()
  const isMobile = useSelector((state) => state.nav?.isMobile)

  const perksDisabled = Boolean(isDemo || externalDemoMode || isLightMode)

  useEffect(() => {
    document.title = "Perks & benefits - Chargeback"
    dispatch(getPerks())
  }, [dispatch])

  const isInitialLoading = fetching && list.length === 0

  return (
    <div className="perks-page" data-testid="perks-page">
      <Row gutter={[24, 24]} align="stretch">
        {isInitialLoading
          ? SKELETON_KEYS.map((key) => (
              <Col key={key} {...breakpoints}>
                <Skeleton.Node active className="perk-card--skeleton" />
              </Col>
            ))
          : list.map((perk) => (
              <Col key={perk.id} {...breakpoints}>
                <PerkCard perk={perk} disabled={perksDisabled} maskPromocode={perksDisabled} />
              </Col>
            ))}
        {!isInitialLoading && (
          <Col xs={24} {...breakpoints}>
            <ComingSoonCard />
          </Col>
        )}
      </Row>
    </div>
  )
}

export default PerksPage
